import { useState, useEffect, type FC } from 'react';

import {
  Button,
  Typography,
  Icon,
  Toastify,
  toast,
  useDeviceType,
} from 'pixel-react';

import { useForgotPasswordMutation } from '@/store/forgotPasswordRequest/forgotPasswordSlice';
import type { DataState } from '@/types/expiredActivation';
import type { SignUpResponse } from '@/types/signUp';

import styles from './ExpiredPasswordLink.module.scss';
import { SignUpWrapper } from '../SignUpWrapper';

export const ExpiredPasswordLink: FC = () => {
  const clientName = import.meta.env.VITE_CLIENT_DETAIL?.name;
  const [forgotPassword] = useForgotPasswordMutation();
  const [data, setData] = useState<DataState>({ emailId: '' });
  const { isMobile } = useDeviceType();
  useEffect(() => {
    const search = window.location.search;

    const emailId = new URLSearchParams(search).get('emailId');
    if (emailId) {
      setData({ emailId: emailId });
    }
  }, []);
  const handleSubmit = async () => {
    try {
      const payLoad = { emailId: data.emailId };
      const response = (await forgotPassword(
        payLoad,
      ).unwrap()) as SignUpResponse;

      if (response.responseCode === 200) {
        toast.success('Reset Link sent successful!');
      }
    } catch (error) {
      console.error('Login failed. Please check your credentials.', error);
    }
  };

  return (
    <SignUpWrapper
      content_header={
        <>
          {' '}
          <Typography fontSize="24px" fontWeight="bold">
            {clientName} AI - Better at being the best
          </Typography>{' '}
        </>
      }
      sub_content={`Using ${clientName}, our customers reap 10x faster scripting, 74% reduction in cost & 54% reduction in maintenance efforts, all at their fingertips.`}
      footer_content={`${clientName}: High Speed Testing, Simplified!`}
      copyright_content={`Copyright © ${clientName} Pvt Ltd. All Rights Reserved`}
      className={styles.exp_link_password_container}
    >
      <section className={styles.form_container}>
        <aside className={styles.exp_password_form}>
          <section className={styles['icon_container']}>
            <Icon
              color=""
              height={isMobile ? 160 : 240}
              width={isMobile ? 160 : 240}
              name="system_warning"
            />
          </section>
          <section className={styles.exp_password_form_header}>
            <Typography
              fontSize="32px"
              textAlign="center"
              className={styles['header_text']}
            >
              Your set password link is <br /> expired !
            </Typography>
            <Typography
              fontSize="16px"
              textAlign="center"
              lineHeight="22px"
              className={styles['sub_header_text']}
            >
              Please check you mail box for a latest link or Click on
            </Typography>
          </section>

          <div className={styles.exp_password_footerBtn}>
            <Button type="submit" variant="primary" onClick={handleSubmit}>
              <Typography fontSize="16px" className={styles['register_btn']}>
                Resend Reset Password Link
              </Typography>
            </Button>
          </div>
        </aside>
      </section>
      <Toastify />
    </SignUpWrapper>
  );
};
